import css from './TerminationConfirmation.module.css';
import React, { useState } from 'react';
import { IoSpeedometerOutline, IoHomeOutline } from "react-icons/io5";
import { ImCalendar } from "react-icons/im";
import { BsCreditCard } from "react-icons/bs";
import { MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";

const TerminationConfirmation = ({ project, step, setStep, nextStep, prevStep, basket, contractDuration = 1, upfront = 0, monthly = 0 }) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    

    return (
        <div className={css.proceedBox}>
            <div className={css.messageBox}>
                <h2>Early Contract Termination or Equipment Payout</h2>
                
                <div className={css.itemBox}>
                    <div className={css.itemWrapper}>
                        <div className={css.icon}>
                
                        </div>
                        <div className={css.item}>
                        <p>This payment plan is scheduled for {contractDuration} payments of ${monthly.toFixed(2)} each. </p>
                        </div>
                    </div>
                </div>
                
                <div className={css.itemBox}>
                    <div className={css.itemWrapper}>
                        <div className={css.icon}>
                        </div>
                        <div className={css.item}>
                        <p>Early termination requires payment of the number of remaining months multiplied by ${monthly.toFixed(2)}</p>

                        </div>
                    </div>
                </div>
                <div className={css.itemBox}>
                    <div className={css.itemWrapper}>
                        <div className={css.icon}>
                        </div>
                        <div className={css.item}>
                        <p>After this payment, the alarm monitoring can either be terminated or continued without further payments for the remaining months.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={css.buttonBox}>
                <div className={css.checkboxBox} >
                    <div className={css.checkbox} onClick={handleCheckboxChange}>
                    {isChecked?<MdOutlineCheckBox/>:<MdOutlineCheckBoxOutlineBlank/>}
                    </div>
                    <div className={css.term}>
                    <p>I acknowledge and accept these conditions</p>
                    </div>
                </div>
                <button 
                    className={css.buttonActive} 
                    onClick={()=>setStep(9)} 
                    >
                        Back
                    </button>
                <button 
                    className={isChecked ? css.buttonActive : css.buttonInActive} 
                    onClick={()=>setStep(11)} 
                    disabled={!isChecked}
                    >
                        Next
                    </button>
            </div>
        </div>
    );
};

export default TerminationConfirmation;







